import _ from 'lodash';
import { BigNumber, ethers } from 'ethers';
import { TCurrency } from 'types/token';

function useFormatNumber() {
    const fCrypto = (number: number | string, digits = 8) => {
        if (_.toNumber(number) <= 0) {
            return number;
        }
        if (digits === undefined) {
            digits = 0;
        }
        const multiplicator = Math.pow(10, digits);
        number = _.toString(number).replace(',', '.');

        number = parseFloat((Number(number) * multiplicator).toFixed(11));

        return (Math.round(number) / multiplicator).toFixed(digits);
    };
    const fFiat = (number: number | string, type: string = 'USD') => {
        let digits;
        if (_.toNumber(number) < 10) {
            digits = 8;
        } else {
            digits = 2;
        }
        if (type === 'VND') {
            digits = 0;
        }
        const moneyUSD = new Intl.NumberFormat('en-EN', {
            currency: type,
            maximumFractionDigits: digits
        }).format(_.toNumber(number));

        return moneyUSD;
    };

    const formatByCurrency = (num: string | number, currency: TCurrency) => {
        switch (currency) {
            case 'USD':
                return `$ ${num}`;
            case 'VND':
                return `${num} VND`;
            default:
                return `$ ${num}`;
        }
    };

    const convertHexToDecimal = (hex: string) => parseInt(hex, 16);
    const converDecimal6 = (decimal: string) => ethers.utils.parseUnits(decimal, 6);
    const transactionFee = (fee: number | BigNumber) => ethers.utils.formatEther(fee);

    const convertBalancetoPriceUsd = (balance: number, price: number) => fFiat(balance * price);
    function formatterCurrency(num: bigint | number) {
        const formatter = Intl.NumberFormat('en', { notation: 'compact' });
        return formatter.format(num);
    }

    return {
        fCrypto,
        fFiat,
        convertHexToDecimal,
        transactionFee,
        convertBalancetoPriceUsd,
        formatterCurrency,
        converDecimal6,
        formatByCurrency
    };
}

export default useFormatNumber;
